export default `
/*
  Warnings:

  - You are about to drop the column \`project_revision_id\` on the \`FileRevision\` table. All the data in the column will be lost.

*/
-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_FileRevision" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "revision_num" INTEGER NOT NULL,
    "revision_name" TEXT NOT NULL,
    "file_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "deleted_at" DATETIME,
    "workspace_id" TEXT NOT NULL,
    CONSTRAINT "FileRevision_file_id_fkey" FOREIGN KEY ("file_id") REFERENCES "File" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "FileRevision_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);
INSERT INTO "new_FileRevision" ("created_at", "created_by", "deleted_at", "file_id", "id", "revision_name", "revision_num", "workspace_id") SELECT "created_at", "created_by", "deleted_at", "file_id", "id", "revision_name", "revision_num", "workspace_id" FROM "FileRevision";
DROP TABLE "FileRevision";
ALTER TABLE "new_FileRevision" RENAME TO "FileRevision";
CREATE INDEX "FileRevision_file_id_idx" ON "FileRevision"("file_id");
CREATE INDEX "FileRevision_created_by_idx" ON "FileRevision"("created_by");
CREATE INDEX "FileRevision_created_at_idx" ON "FileRevision"("created_at");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;
`;
